import { useEffect, useMemo, useState } from "react";

import {
  Alert,
  Avatar,
  Box,
  Button,
  Chip,
  Container,
  Grid,
  makeStyles,
  Snackbar,
  Typography,
} from "@eGroupTeam/material";
import { useSelector } from "react-redux";
import { clearApplySuccess, getApplySuccess } from "utils/applySuccessHelper";
import s3Url from "utils/s3Url";
import useLocationSearch from "utils/useLocationSearch";

import Center from "@eGroupTeam/material-layout/Center";
import { green } from "@material-ui/core/colors";
import { Redirect, useHistory } from "react-router-dom";

import {
  getActivityUserModelTrainUser,
  getActivityUserModelTrainUserFacePath,
} from "landingPages/Train/redux";
import { getApplyDoneUser } from "../ActivityApply/redux";

const useStyles = makeStyles((theme) => ({
  main: {
    background: "#fff",
  },
  avatar: {
    width: 150,
    height: 150,
    margin: "auto",
    marginBottom: theme.spacing(2),
  },
  center: {
    display: "flex",
    justifyContent: "center",
  },
  chip: {
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  btn: {
    margin: theme.spacing(0, 1),
  },
  successAlert: {
    backgroundColor: green[700],
    color: "#fff",
    fontWeight: "bold",
    fontSize: "1rem",
    "& .MuiAlert-icon": {
      color: "#fff",
    },
  },
}));

const ActivityApplyDone = ({ activity }) => {
  const history = useHistory();
  const classes = useStyles();
  const userFacePath = useSelector(getActivityUserModelTrainUserFacePath);
  const trainUser = useSelector(getActivityUserModelTrainUser);
  const applyUser = useSelector(getApplyDoneUser);
  const { type, qrcodeTokenId } = useLocationSearch();
  const isTrainType = type === "train";
  const user = useMemo(
    () => (isTrainType ? trainUser : applyUser),
    [applyUser, isTrainType, trainUser]
  );

  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [localStorageUser, setLocalStorageUser] = useState(null);

  useEffect(() => {
    try {
      // 檢查是否有報名成功的記錄
      const storedData = getApplySuccess();
      if (storedData && storedData.activityId === activity.get("activityId")) {
        setLocalStorageUser(storedData);
        setShowSuccessNotification(true);

        // 顯示5秒後自動關閉
        setTimeout(() => {
          setShowSuccessNotification(false);
        }, 5000);

        // 使用後清除，避免重複顯示
        setTimeout(() => {
          clearApplySuccess();
        }, 30000);
      }
    } catch (error) {
      console.error("檢查報名狀態時出錯", error);
    }
  }, [activity]);

  // 如果Redux沒有用戶數據但有localStorage數據，使用localStorage數據
  const displayUser =
    user ||
    (localStorageUser && {
      get: (key) => localStorageUser?.[key] ?? null,
    });

  if (!displayUser) {
    return <Redirect to={`/activities/${activity.get("activityId")}`} />;
  }

  return (
    <Center>
      <Container maxWidth="sm">
        <Box px={4} py={6}>
          {userFacePath && (
            <Avatar
              classes={{ root: classes.avatar }}
              src={s3Url(userFacePath)}
            />
          )}
          <Grid container direction="column" spacing={2}>
            <Grid item xs={12}>
              <Typography align="center" variant="h6">
                報名完成!
              </Typography>
            </Grid>
            <Grid item className={classes.center} xs={12}>
              <div>
                <Typography gutterBottom align="center">
                  {displayUser.get("userName")}
                </Typography>
                <Typography gutterBottom align="center">
                  {displayUser.get("userPhone")}
                </Typography>
                <Typography align="center">
                  {displayUser.get("userEmail")}
                </Typography>
              </div>
            </Grid>
            <Grid item className={classes.center} xs={12}>
              <Chip
                label="活動前寄送行前通知與報到資訊"
                variant="outlined"
                className={classes.chip}
              />
            </Grid>
            <Grid item className={classes.center} xs={12}>
              <div>
                <Button
                  className={classes.btn}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    history.push(`/activities/${activity.get("activityId")}`);
                  }}
                >
                  返回活動
                </Button>
                {isTrainType && (
                  <Button
                    className={classes.btn}
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      history.push(
                        `/train?qrcodeTokenId=${qrcodeTokenId}&activityId=${activity.get(
                          "activityId"
                        )}`
                      );
                    }}
                  >
                    重新拍照
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </Box>

        {/* 報名成功通知 */}
        <Snackbar
          open={showSuccessNotification}
          autoHideDuration={5000}
          onClose={() => setShowSuccessNotification(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setShowSuccessNotification(false)}
            severity="success"
            variant="filled"
            classes={{ root: classes.successAlert }}
          >
            您已成功報名此活動！
          </Alert>
        </Snackbar>
      </Container>
    </Center>
  );
};

export default ActivityApplyDone;
